import { OwaDate, owaDate, addMinutes, isBefore, differenceInMinutes } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import owaDateFromTzDateTimeValues from './owaDateFromTzDateTimeValues';

/**
 * This function returns new start and end time based the change of the start time
 * It updates the start time and not the date
 * Preserves meeting duration if the new time is after or equal to the end
 */

export default function getDatesOnStartTimeChanged(
    prevStartDate: OwaDate,
    prevEndDate: OwaDate,
    newDate: OwaDate,
    shouldAlwaysKeepDuration: boolean
): OwaDateRange {
    if (prevStartDate && prevEndDate && newDate) {
        let newStart = owaDateFromTzDateTimeValues(prevStartDate.tz, prevStartDate, newDate);

        let newEnd: OwaDate = prevEndDate;
        if (!isBefore(newStart, prevEndDate) || shouldAlwaysKeepDuration) {
            // If start is not before end, then update end time based on the meeting duration
            let meetingDuration = differenceInMinutes(prevEndDate, prevStartDate);
            newEnd = owaDate(prevEndDate.tz, addMinutes(newStart, meetingDuration));
        }

        return {
            start: newStart,
            end: newEnd,
        };
    }
    return null;
}
